'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopUpFlow = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Pending = require('components/Profile/Pending');

var _Confirmation = require('../ModalStates/Confirmation');

var _Failure = require('../ModalStates/Failure');

var _TopUp = require('./TopUp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopUpFlow = exports.TopUpFlow = function (_Component) {
  (0, _inherits3.default)(TopUpFlow, _Component);

  function TopUpFlow() {
    (0, _classCallCheck3.default)(this, TopUpFlow);
    return (0, _possibleConstructorReturn3.default)(this, (TopUpFlow.__proto__ || (0, _getPrototypeOf2.default)(TopUpFlow)).apply(this, arguments));
  }

  (0, _createClass3.default)(TopUpFlow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onModalOpen();
    }
  }, {
    key: 'renderConfirmation',
    value: function renderConfirmation() {
      var _props = this.props,
          address = _props.address,
          description = _props.description,
          endTime = _props.endTime,
          klassName = _props.klassName,
          location = _props.location,
          onModalClose = _props.onModalClose,
          startTime = _props.startTime,
          timeZone = _props.timeZone,
          venueName = _props.venueName,
          venueId = _props.venueId;


      return _react2.default.createElement(_Confirmation.Confirmation, {
        address: address,
        description: description,
        endTime: endTime,
        klassName: klassName,
        location: location,
        onModalClose: onModalClose,
        startTime: startTime,
        timeZone: timeZone,
        venueName: venueName,
        venueId: venueId
      });
    }
  }, {
    key: 'renderFailure',
    value: function renderFailure() {
      var _props2 = this.props,
          error = _props2.error,
          imageUrl = _props2.imageUrl,
          onModalClose = _props2.onModalClose,
          venueName = _props2.venueName;


      return _react2.default.createElement(_Failure.Failure, {
        errorMessage: error.message,
        imageUrl: imageUrl,
        onModalClose: onModalClose,
        venueName: venueName
      });
    }
  }, {
    key: 'renderLoading',
    value: function renderLoading() {
      return _react2.default.createElement(
        _Pending.Pending,
        null,
        _react2.default.createElement(_Pending.Pending.CheckingAvailability, null)
      );
    }
  }, {
    key: 'renderTopUp',
    value: function renderTopUp() {
      var _props3 = this.props,
          cancellationPolicy = _props3.cancellationPolicy,
          credits = _props3.credits,
          creditsNeeded = _props3.creditsNeeded,
          creditsBalance = _props3.creditsBalance,
          currencyCode = _props3.currencyCode,
          endOfCycleDate = _props3.endOfCycleDate,
          endTime = _props3.endTime,
          includeTax = _props3.includeTax,
          onReservationRequest = _props3.onReservationRequest,
          klassName = _props3.klassName,
          lateCancellation = _props3.lateCancellation,
          cost = _props3.cost,
          msaTimeZone = _props3.msaTimeZone,
          scheduleId = _props3.scheduleId,
          source = _props3.source,
          startTime = _props3.startTime,
          timeZone = _props3.timeZone,
          venueId = _props3.venueId,
          venueName = _props3.venueName;


      return _react2.default.createElement(_TopUp.TopUp, {
        cancellationPolicy: cancellationPolicy,
        credits: credits,
        creditsNeeded: creditsNeeded,
        creditsBalance: creditsBalance,
        currencyCode: currencyCode,
        endOfCycleDate: endOfCycleDate,
        endTime: endTime,
        includeTax: includeTax,
        onReservationRequest: onReservationRequest,
        klassName: klassName,
        lateCancellation: lateCancellation,
        cost: cost,
        msaTimeZone: msaTimeZone,
        scheduleId: scheduleId,
        source: source,
        startTime: startTime,
        timeZone: timeZone,
        venueId: venueId,
        venueName: venueName
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          loaded = _props4.loaded,
          loading = _props4.loading,
          error = _props4.error;


      var content = this.renderTopUp();

      if (loading) {
        content = this.renderLoading();
      }

      if (loaded) {
        content = this.renderConfirmation();
      }

      if (error) {
        content = this.renderFailure();
      }

      return content;
    }
  }]);
  return TopUpFlow;
}(_react.Component);

TopUpFlow.propTypes = {
  loaded: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  error: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),

  endOfCycleDate: _propTypes2.default.number,
  msaTimeZone: _propTypes2.default.string,

  address: _propTypes2.default.shape({
    address_line1: _propTypes2.default.string,
    city: _propTypes2.default.string,
    state: _propTypes2.default.string,
    zip_code: _propTypes2.default.string
  }),
  cancellationPolicy: _propTypes2.default.string,
  cost: _propTypes2.default.number,
  credits: _propTypes2.default.number,
  creditsNeeded: _propTypes2.default.number,
  creditsBalance: _propTypes2.default.number,
  currencyCode: _propTypes2.default.string,
  description: _propTypes2.default.string,
  endTime: _propTypes2.default.number,
  includeTax: _propTypes2.default.bool,
  klassName: _propTypes2.default.string,
  location: _propTypes2.default.string,
  onModalOpen: _propTypes2.default.func,
  onModalClose: _propTypes2.default.func,
  onReservationRequest: _propTypes2.default.func,
  lateCancellation: _propTypes2.default.string,
  scheduleId: _propTypes2.default.number,
  source: _propTypes2.default.string,
  startTime: _propTypes2.default.number,
  imageUrl: _propTypes2.default.string,
  timeZone: _propTypes2.default.string,
  venueId: _propTypes2.default.number,
  venueName: _propTypes2.default.string
};